import * as React from "react";

const GraphicHomeFeaturedDoubleBlock: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="1309" height="600" viewBox="0 0 1309 600" fill="currentColor"><g fill="#FFF" fillRule="evenodd" opacity=".1"><polygon points="280.266 40 1309 40 1138.734 599.719 110 599.719"/><polygon points="170.266 0 1269 0 1098.734 559.719 0 559.719"/></g></svg>;
};

export default React.memo(GraphicHomeFeaturedDoubleBlock);
